import { useId, type ReactNode } from 'react';
import { FiX } from 'react-icons/fi';

import styles from '@/admin/components/AdminSidePanel.module.scss';
import { SidePanel } from '@/components/SidePanel';

type AdminSidePanelProps = {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
};

/**
 * The app's SidePanel in admin's palette. The panel is portalled out of AdminLayout, so its
 * content re-declares the --vh-* tokens it would otherwise lose.
 */
export const AdminSidePanel = ({ open, onClose, title, children }: AdminSidePanelProps) => {
  const titleId = useId();

  return (
    <SidePanel open={open} onClose={onClose}>
      <div className={styles.content} role="dialog" aria-labelledby={titleId}>
        <div className={styles.header}>
          <div id={titleId} className={styles.title}>
            {title}
          </div>
          <button type="button" className={styles.close} aria-label="Close" onClick={onClose}>
            <FiX />
          </button>
        </div>

        <div className={styles.body}>{children}</div>
      </div>
    </SidePanel>
  );
};
